module.exports = {
  BASE_HOST: process.env.REACT_APP_BASE_HOST || 'localhost',
  API_HOST: process.env.REACT_APP_API_HOST || 'http://localhost:8081',
  TOKEN_COOKIE_NAME: process.env.REACT_APP_TOKEN_COOKIE_NAME || 'mozermovie',
  LOCALE: process.env.REACT_APP_LOCALE || 'ja',
};
